import { MONTHS } from '@/constants';

export const forceFileDownload = (response, name) => {
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', name);
  document.body.appendChild(link);
  link.click();
};

export const capitalizeAddressData = (text) => {
  const textArr = text.toLowerCase().split('');
  const capitalized = textArr.map((char, index) => {
    if (index > 0) {
      const prevChar = textArr[index - 1];
      if (prevChar === ' ' || prevChar === '-') {
        return char.toUpperCase();
      }
    } else {
      return char.toUpperCase();
    }
    return char;
  }).join('');

  const capitalizedArr = capitalized.split(' ');
  const formatted = capitalizedArr.map((word) => {
    if (word === 'Of' || word === 'And') {
      return word.toLowerCase();
    }

    return word;
  }).join(' ');

  return formatted;
};

export const reformatSsn = ssn => ssn.split('-').join('');

export const formatSsn = (ssn) => {
  let reformattedSsn = ssn;
  if (ssn.includes('-')) reformattedSsn = ssn;
  return reformattedSsn.replace(/(\d{3})(\d{2})(\d{4})/,
    '$1-$2-$3');
};

export const formatEin = (ein) => {
  let reformattedEin = ein;
  const pattern = /^\d{2}-\d{7}$/;
  if (ein.match(pattern)) {
    reformattedEin = ein;
    return reformattedEin;
  }
  if (ein.includes('-')) {
    const einNumbers = ein.split('-').join('');
    reformattedEin = einNumbers.replace(/(\d{2})(\d{7})/,
      '$1-$2');
    return reformattedEin;
  }
  return reformattedEin.replace(/(\d{2})(\d{7})/,
    '$1-$2');
};

export const formatPhone = phone => (phone ? phone.toString().replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3') : '');

export const getPossibleYears = () => {
  const min = 1990;
  const currentYear = new Date().getFullYear();

  const years = [];
  for (let i = min; i <= currentYear; i += 1) {
    years.push(i.toString());
  }

  return years;
};

export const getFutureYears = () => {
  const min = new Date().getFullYear();
  const currentYear = min + 100;

  const years = [];
  for (let i = min; i <= currentYear; i += 1) {
    years.push(i.toString());
  }

  return years;
};

export const getFutureMonths = (year) => {
  if (year === new Date().getFullYear()) {
    const currentMonth = new Date().getMonth();
    return MONTHS.filter((month, index) => index >= currentMonth);
  }

  return MONTHS;
};

export const formatDateToCalendar = (date) => {
  if (date.match(/\d{2}\/\d{2}\/\d{2,4}/)) {
    const [month, day, year] = date.split('/');
    return `${year}-${month}-${day}`;
  }

  return date;
};

export const daysInMonth = (month, year) => new Date(year, month, 0).getDate();

export const addZeroToDayOrMonth = dayOrMonth => (dayOrMonth < 10 ? `0${dayOrMonth}` : dayOrMonth);

export const formatDate = (date) => {
  if (!date) return null;
  const dateStr = new Date(date);
  const month = addZeroToDayOrMonth(dateStr.getMonth() + 1);
  const day = addZeroToDayOrMonth(dateStr.getDate());
  const year = dateStr.getFullYear();
  return `${month}/${day}/${year}`;
};

export const formatDateForAdminTable = (date) => {
  if (!date) return null;
  return new Date(date).toLocaleDateString('en-US', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
};

export function subtractYearsFromDate(date, yearsToSubtract) {
  const maxPastDelta = yearsToSubtract;
  const maxYear = date.getFullYear() - maxPastDelta;
  const maxMonth = date.getMonth();
  const maxDate = date.getDate();
  return new Date(maxYear, maxMonth, maxDate);
}
